import { Form, Input } from "decorator-form";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import InputType from "common/form/InputType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import Course from "../entities/Course";
import * as badgeFragments from "../fragments/badge/displayFragments";
import * as actionFragments from "../fragments/course/actionFragments";
import * as displayFragments from "../fragments/course/displayFragments";
import * as programFragments from "../fragments/program/displayFragments";
import * as courseItemFragments from "../fragments/courseItem/displayFragments";

const CourseSelect = EntitySelect.registered({
	entity: Course,
	type: 'one',
	getText: 'title'
}, 'string');

const courseLayout = FragmentProvider.getLayoutInput({...displayFragments, ...actionFragments});
const badgeDisplayField = FragmentProvider.getLayoutInput(badgeFragments);
const programDisplayField = FragmentProvider.getLayoutInput(programFragments);
const courseItemLayout = FragmentProvider.getLayoutInput(courseItemFragments);

@Form({title: "Course Details"})
export default class CourseDetailsPanelConfig {

	@Input({type: CourseSelect, title: "Course to display"})
	public entryId: number;

	@Input({type: courseLayout, title: "Layout"})
	public courseLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: courseLayout, title: "Child Product Layout"})
	public childrenLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: courseLayout, title: "Course Item Layout"})
	public courseItemLayout: ILayout<IFragmentLayoutConfig>;

	// TODO make this not be needed
	@Input({type: InputType.CHECKBOX, title: "Language Packages Enabled"})
	public languagePackagesEnabled: boolean;

	@Input({type: badgeDisplayField, title: "Badge Layout"})
	public badgeLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: programDisplayField, title: "Program Layout"})
	public programLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: badgeDisplayField, title: "Program Badge Layout"})
	public programBadgeLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: InputType.CHECKBOX, title: "Lazy load"})
	public lazyLoad: boolean;

	@Input({ type: InputType.NUMBER, title: "Lazy load size" })
	public lazyLoadSize?: number = 3;

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

	@Input({type: InputType.CHECKBOX, title: "Login Before Buy", description: "prompts for sso upon buy for non logged-in user and redirects to course details page after sso"})
	public loginBeforeBuy: boolean = false;

	
	@Input({type: InputType.CHECKBOX, title: "Disable Direct buy", description: "disable redirect to 3rd party cart"})
       public disableDirectBuy: boolean = false;

    @Input({type: InputType.TEXT, title: "SSO Redirect Page Upon Buy", description: "Redirects the non logged in user here on click buy button. example value: course-details"})
	public buySSORedirectPage: string;
	
	@Input({type: InputType.CHECKBOX, title: "Direct buy", description: "redirect to 3rd party cart"})
	public directBuy: boolean = false;
	
	@Input({type: InputType.TEXT, title: "Show Custom fields"})
	public showCustomFields: string;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/config/CourseDetailsPanelConfig.ts